import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
export enum Status {
  NOT_STARTED = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum ReturnProcessActivity {
  MARK_AS_PROCESSED_ACTIVITY = "markAsProcessedActivity",
  POST_PROCESSED_EVENTS_ACTIVITY = "postProcessedEventsActivity",
  SAVE_FINAL_TOTALS_ACTIVITY = "saveFinalTotalsActivity",
  EXPIRE_HAPPY_RETURNS_RMA_ACTIVITY = "expireHappyReturnsRmaActivity",
  CLOSE_SHOPIFY_RETURN_ACTIVITY = "closeShopifyReturnActivity",
  CLOSE_SHOPIFY_ORDER_ACTIVITY = "closeShopifyOrderActivity",
  APPEND_BIGCOMMERCE_STAFF_NOTES_ACTIVITY = "appendBigcommerceStaffNotesActivity",
  YOFI_FRAUD_DETECTION_CHARGE_ACTIVITY = "yofiFraudDetectionChargeActivity",
  INSTANT_EXCHANGE_RECOVERY_FEE_REFUND_ACTIVITY = "instantExchangeRecoveryFeeRefundActivity",
  UPDATE_ITEM_DISPOSITIONING_AUDIT_LOG_ACTIVITY = "updateItemDispositioningAuditLogActivity",
  UPDATE_REJECTION_AND_INVOICE_TIMELINE_ACTIVITY = "updateRejectionAndInvoiceTimelineActivity",
  TRIGGER_RETURN_PROCESSED_EVENT_ACTIVITY = "triggerReturnProcessedEventActivity",
  REMOVE_FAILURE_TAG_ACTIVITY = "removeFailureTagActivity",
  RESTOCK_ITEMS_ACTIVITY = "restockItemsActivity",
  KATANA_RESTOCK_ACTIVITY = "katanaRestockActivity",
  LUMINOUS_RESTOCK_ACTIVITY = "luminousRestockActivity",
  REIMBURSE_EW_ACTIVITY = "reimburseEwActivity",
  PROCESS_REPAIRS_ACTIVITY = "processRepairsActivity",
  CREATE_EXCHANGE_SALES_ORDER_ACTIVITY = "createExchangeSalesOrderActivity",
  DISPOSE_REVERSE_FULFILLMENT_ORDER_ACTIVITY = "disposeReverseFulfillmentOrderActivity",
  CREATE_STORE_CREDIT_ACTIVITY = "createStoreCreditActivity",
  SEND_RETURN_PROCESSED_EMAIL_ACTIVITY = "sendReturnProcessedEmailActivity",
  CREATE_FINAL_SALE_CREDIT_ACTIVITY = "createFinalSaleCreditActivity",
  FINAL_RMA_UPDATE_ACTIVITY = "finalRMAUpdateActivity",
  TEMPORAL_PROCESS_ITEMS = "temporalProcessItems",
  CREATE_REFUND_ACTIVITY = "createRefundActivity",
  INTEGRATION_RETURN_PROCESSED_ACTIVITY = "integrationReturnProcessedActivity",
  UPDATE_IS_PROCESSING_ACTIVITY = "updateIsProcessingActivity",
  COMMENTSOLD_MARK_AS_RETURNED_AND_RESTOCK_ACTIVITY = "commentsoldMarkAsReturnedAndRestockActivity",
  HANDLE_LOYALTY_ACTIVITY = "handleLoyaltyActivity",
  CREATE_SHOPIFY_EXCHANGE_ACTIVITY = "createShopifyExchangeActivity",
  CREATE_BIGCOMMERCE_EXCHANGE_ACTIVITY = "createBigcommerceExchangeActivity",
  CREATE_COMMENTSOLD_EXCHANGE_ACTIVITY = "createCommentsoldExchangeActivity",
  CREATE_SFCC_EXCHANGE_ACTIVITY = "createSfccExchangeActivity",
  CHECK_REFUND_ID_DOUBLE_RETURN_ACTIVITY = "checkRefundIdDoubleReturnActivity",
  SET_PRODUCTS_PROCESSED_INFO_ACTIVITY = "setProductsProcessedInfoActivity",
  IS_OOS_HALTED_ACTIVITY = "isOosHaltedActivity",
}

export enum ReturnCreationActivity {
  INCREMENT_RETURN_SUBMITTED_ACTIVITY = "incrementReturnSubmittedActivity",
  TRIGGER_CUSTOMER_EVENT_ACTIVITY = "triggerCustomerEventActivity",
  FEATURE_FLAG_METRICS_ACTIVITY = "featureFlagMetricsActivity",
  POPULATE_TIMELINE_ACTIVITY = "populateTimelineActivity",
  CREATE_EXCHANGE_ACTIVITY = "createExchangeActivity",
  CREATE_REPAIR_INVOICE_ACTIVITY = "createRepairInvoiceActivity",
  COLLECT_FEDEX_EASY_RETURN_PAYMENT_ACTIVITY = "collectFedexEasyReturnPaymentActivity",
  CREATE_SHOPIFY_RETURN_ACTIVITY = "createShopifyReturnActivity",
  UPDATE_SHOP_APP_METAFIELDS_ACTIVITY = "updateShopAppMetafieldsActivity",
  CREATE_UPSELL_CHARGE_ACTIVITY = "createUpsellChargeActivity",
  NOTIFY_AND_TRIGGER_STATUS_CHANGE_ACTIVITY = "notifyAndTriggerStatusChangeActivity",
  RETURN_CREATION_EMAIL_ACTIVITY = "returnCreationEmailActivity",
  VERIFY_ORDER_SCHEMA_ACTIVITY = "verifyOrderSchemaActivity",
  UPDATE_BIGCOMMERCE_ORDER_ACTIVITY = "updateBigCommerceOrderActivity",
  MARK_GIFT_RECEIPT_AS_USED_ACTIVITY = "markGiftReceiptAsUsedActivity",
  CREATE_PROACTIVE_SHIPPING_CLAIM_ACTIVITY = "createProactiveShippingClaimActivity",
  // Merchant notifications
  SEND_CLAIM_WARRANTY_NOTIFICATION_EMAIL_ACTIVITY = "sendClaimWarrantyNotificationEmailActivity",
  SEND_RETURN_NOTIFICATION_EMAIL_ACTIVITY = "sendReturnNotificationEmailActivity",
  SEND_NEEDS_REVIEW_NOTIFICATION_EMAIL_ACTIVITY = "sendNeedsReviewNotificationEmailActivity",
  // End merchant notifications
  SEND_EXCHANGE_NOTIFICATION_EMAIL_ACTIVITY = "sendExchangeNotificationEmailActivity",
  SEND_RETURN_TRACKING_NOTIFICATION_ACTIVITY = "sendReturnTrackingNotificationActivity",
  TAG_ORIGINAL_ORDER_ACTIVITY = "tagOriginalOrderActivity",
  REMOVE_FAILURE_TAG_ACTIVITY = "removeFailureTagActivity",
  GENERATE_TEAM_SPECIFIC_EXTERNAL_ID_ACTIVITY = "generateTeamSpecificExternalIdActivity",
  AGENT_RETURN_REVIEW_ACTIVITY = "agentReturnReviewActivity",
  AGENT_FRAUD_REVIEW_ACTIVITY = "agentFraudReviewActivity",
  AUDIT_PACKAGE_PICKUP_ACTIVITY = "auditPackagePickupActivity",
  CHECK_MANUAL_REVIEW_ACTIVITY = "checkManualReviewActivity",
  REPORT_CLAIM_TO_PROVIDER_ACTIVITY = "reportClaimToProviderActivity",
  TRIGGER_STATUS_CHANGE_ACTIVITY_FOR_CREATION = "triggerStatusChangeActivityForCreation",
}

export enum ReturnReadyActivity {
  ADD_TRACKING_TO_SHOPIFY_RETURN_ACTIVITY = "addTrackingToShopifyReturnActivity",
  BILL_FOR_RECYCLE_REQUEST_ACTIVITY = "billForRecycleRequestActivity",
  CHARGE_PER_RETURN_FEE_ACTIVITY = "chargePerReturnFeeActivity",
  CREATE_MANUAL_LABEL_PACKING_SLIP_ACTIVITY = "createManualLabelPackingSlipActivity",
  CREATE_IN_STORE_PACKING_SLIP_ACTIVITY = "createInStorePackingSlipActivity",
  CREATE_EXCHANGE_ACTIVITY = "createExchangeActivity",
  CREATE_LABEL_ACTIVITY = "createLabelActivity",
  REFUND_LABEL_ACTIVITY = "refundLabelActivity",
  SELECT_RETURNBEAR_CASE_METHOD_ACTIVITY = "selectReturnbearCaseMethodActivity",
  SEND_RETURN_APPROVED_EMAIL_ACTIVITY = "sendReturnApprovedEmailActivity",
  COLLECT_POS_PAYMENT_ACTIVITY = "collectPosPaymentActivity",
  COLLECT_EXTERNAL_RETURN_SHIPPING_PAYMENT_ACTIVITY = "collectExternalReturnShippingPaymentActivity",
  CREATE_RMA_VIA_CUSTOM_INTEGRATION_ACTIVITY = "createRmaViaCustomIntegrationActivity",
  CREATE_INMAR_RMA_ACTIVITY = "createInmarRmaActivity",
  CREATE_BLUEYONDER_RMA_ACTIVITY = "createBlueYonderRmaActivity",
  SEND_DROPSHIP_NOTIFICATION_EMAIL_ACTIVITY = "sendDropshipNotificationEmailActivity",
  UPDATE_RETURN_WITH_SHIPPING_REFUND_ACTIVITY = "updateReturnWithShippingRefundActivity",
  TRIGGER_STATUS_CHANGE_ACTIVITY = "triggerStatusChangeActivity",
  CHECK_PICKUP_DATE_EXPIRATION_ACTIVITY = "checkPickupDateExpirationActivity",
  POS_TRIGGER_PROCESSING_ACTIVITY = "posTriggerProcessingActivity",
  REMOVE_FAILURE_TAG_ACTIVITY = "removeFailureTagActivity",
  CHARGE_REDO_MANAGED_RETURNS_ACTIVITY = "chargeRedoManagedReturnsActivity",
  GENERATE_DROPOFF_QR_CODE_ACTIVITY = "generateDropoffQrCodeActivity",
  TRIGGER_RETURN_APPROVAL_PROCESSING_FLOW_ACTIVITY = "triggerReturnApprovalProcessingFlowActivity",
}

export enum PostReturnReadyActivity {
  REMOVE_FAILURE_TAG_ACTIVITY = "removeFailureTagActivity",
  BILL_FOR_RECYCLE_REQUEST_ACTIVITY = "billForRecycleRequestActivity",
  CHARGE_PER_RETURN_FEE_ACTIVITY = "chargePerReturnFeeActivity",
  CHARGE_REDO_MANAGED_RETURNS_ACTIVITY = "chargeRedoManagedReturnsActivity",
  SEND_RETURN_APPROVED_EMAIL_ACTIVITY = "sendReturnApprovedEmailActivity",
  COLLECT_POS_PAYMENT_ACTIVITY = "collectPosPaymentActivity",
  COLLECT_EXTERNAL_RETURN_SHIPPING_PAYMENT_ACTIVITY = "collectExternalReturnShippingPaymentActivity",
  CREATE_RMA_VIA_CUSTOM_INTEGRATION_ACTIVITY = "createRmaViaCustomIntegrationActivity",
  CREATE_INMAR_RMA_ACTIVITY = "createInmarRmaActivity",
  UPDATE_RETURN_WITH_SHIPPING_REFUND_ACTIVITY = "updateReturnWithShippingRefundActivity",
  TRIGGER_STATUS_CHANGE_ACTIVITY = "triggerStatusChangeActivity",
  SEND_DROPSHIP_NOTIFICATION_EMAIL_ACTIVITY = "sendDropshipNotificationEmailActivity",
  CHECK_PICKUP_DATE_EXPIRATION_ACTIVITY = "checkPickupDateExpirationActivity",
  POS_TRIGGER_PROCESSING_ACTIVITY = "posTriggerProcessingActivity",
  TRIGGER_REFUND_RETURN_SUBMITTED_ACTIVITY = "triggerRefundReturnSubmittedActivity",
  TRIGGER_RETURN_APPROVAL_PROCESSING_FLOW_ACTIVITY = "triggerReturnApprovalProcessingFlowActivity",
  GENERATE_PRODUCT_PROCESSING_SPECS_ACTIVITY = "generateProductProcessingSpecsActivity",
  SHOULD_GENERATE_PRODUCT_PROCESSING_SPEC_ACTIVITY = "shouldGenerateProductProcessingSpecActivity",
}

export enum PostReturnProcessActivity {
  REMOVE_FAILURE_TAG_ACTIVITY = "removeFailureTagActivity",
  CREATE_PER_EXCHANGE_PAYOUT_ORDER_ACTIVITY = "createPerExchangePayoutOrderActivity",
  CREDIT_MERCHANT_FOR_MANAGED_CLAIM_ACTIVITY = "creditMerchantForManagedClaimActivity",
  TRIGGER_EXCHANGE_PROCESSED_WITH_CREDIT_ACTIVITY = "triggerExchangeProcessedWithCreditActivity",
}

export enum ExchangeConversionActivity {
  UPDATE_RETURN_FOR_EXCHANGE_ACTIVITY = "updateReturnForExchangeActivity",
  CREATE_EXCHANGE_CONVERSION_ACTIVITY = "createExchangeConversionActivity",
  REMOVE_FAILURE_TAG_ACTIVITY = "removeFailureTagActivity",
}

export enum Workflow {
  RETURN_CREATION_SIDE_EFFECTS = "returnCreationSideEffects",
  RETURN_READY_SIDE_EFFECTS = "returnReadySideEffects",
  POST_RETURN_READY_SIDE_EFFECTS = "postReturnReadySideEffects",
  EXCHANGE_CONVERSION = "exchangeConversion",
  RETURN_PROCESS_SIDE_EFFECTS = "returnProcessSideEffects",
  POST_RETURN_PROCESS_SIDE_EFFECTS = "postReturnProcessSideEffects",
  TRIGGER_PROCESSING = "triggerProcessing",
}

export const workflowToFailureTagMapping: Record<Workflow, string> = {
  [Workflow.RETURN_CREATION_SIDE_EFFECTS]: "Creation details failed",
  [Workflow.RETURN_READY_SIDE_EFFECTS]: "Ready side effects failed",
  [Workflow.POST_RETURN_READY_SIDE_EFFECTS]: "Post ready side effects failed",
  [Workflow.EXCHANGE_CONVERSION]: "Exchange conversion failed",
  [Workflow.RETURN_PROCESS_SIDE_EFFECTS]: "Processing failed",
  [Workflow.POST_RETURN_PROCESS_SIDE_EFFECTS]:
    "Post process side effects failed",
  [Workflow.TRIGGER_PROCESSING]: "Trigger processing failed",
};

export const BaseActivityStatusSchema = z.object({
  status: createEnum(Status),
  error: z.string().nullish(),
  failureMessage: z.string().optional(),
  failureTime: z.date().optional(),
  nonRetryable: z.boolean().optional(),
});

export const ReturnCreationStatusSchema = BaseActivityStatusSchema.extend({
  workflow: z.literal(Workflow.RETURN_CREATION_SIDE_EFFECTS),
  name: createEnum(ReturnCreationActivity),
});
export const ReturnProcessStatusSchema = BaseActivityStatusSchema.extend({
  workflow: z.literal(Workflow.RETURN_PROCESS_SIDE_EFFECTS),
  name: createEnum(ReturnProcessActivity),
});
export const FallbackReturnCreationStatusSchema =
  BaseActivityStatusSchema.extend({
    workflow: z.undefined(),
    name: createEnum(ReturnCreationActivity),
  });

export const ReturnReadyStatusSchema = BaseActivityStatusSchema.extend({
  workflow: z.literal(Workflow.RETURN_READY_SIDE_EFFECTS),
  name: createEnum(ReturnReadyActivity),
});

export const PostReturnReadyStatusSchema = BaseActivityStatusSchema.extend({
  workflow: z.literal(Workflow.POST_RETURN_READY_SIDE_EFFECTS),
  name: createEnum(PostReturnReadyActivity),
});

export const PostReturnProcessStatusSchema = BaseActivityStatusSchema.extend({
  workflow: z.literal(Workflow.POST_RETURN_PROCESS_SIDE_EFFECTS),
  name: createEnum(PostReturnProcessActivity),
});

export const ExchangeConversionStatusSchema = BaseActivityStatusSchema.extend({
  workflow: z.literal(Workflow.EXCHANGE_CONVERSION),
  name: createEnum(ExchangeConversionActivity),
});

export const ActivityStatusSchema = z.discriminatedUnion("workflow", [
  ReturnCreationStatusSchema,
  ReturnProcessStatusSchema,
  ReturnReadyStatusSchema,
  PostReturnReadyStatusSchema,
  PostReturnProcessStatusSchema,
  ExchangeConversionStatusSchema,
  FallbackReturnCreationStatusSchema,
]);
export type ActivityStatus = z.infer<typeof ActivityStatusSchema>;

export const WorkflowTaskStatusSchema = z.object({
  status: createEnum(Status),
  error: z.string().nullish(),
  failure: z.string().nullish(),
  retryCount: z.number().optional(),
  lastFailureTime: z.date().nullish(),
});
export type WorkflowTaskStatus = z.infer<typeof WorkflowTaskStatusSchema>;
